var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cmpTableWithMenu',{attrs:{"name":_vm.name,"pkColumn":_vm.pkColumn,"fields":_vm.fields,"qryFields":_vm.qryFields,"children":_vm.children,"parent":_vm.parent,"header":_vm.header,"tableFuncs":_vm.tableFuncs,"moreTableFuncs":_vm.moreTableFuncs}})
}
var staticRenderFns = []

export { render, staticRenderFns }